import Axios from 'axios';

export default Axios.create({
  // baseURL: 'http://localhost:8080/api',
  baseURL: 'https://eloadmin.com.br:8443/admin/api',
  withCredentials: true,
});
